import { NgModule } from '@angular/core';

import { MenuItems } from './menu-items/menu-items';
import { HorizontalMenuItems } from './menu-items/horizontal-menu-items';
import { HighChartComponent } from './high-chart/high-chart.component';


import {
  AccordionAnchorDirective,
  AccordionLinkDirective,
  AccordionDirective
} from './accordion';
import { HighChartCasinoComponent } from './high-chart-casino/high-chart-casino.component';

@NgModule({
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    HighChartComponent,
    HighChartCasinoComponent
  ],
  exports: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    HighChartComponent,
    HighChartCasinoComponent
  ],
  providers: [MenuItems, HorizontalMenuItems]
})
export class SharedModule { }
